export const PRODUCT_BLOG_POST_PROMPTS = {
    TITLE: {
        title: 'Creates Blog Post Titles',
        prompt: 'Check out this product URL and suggest a few SEO-Friendly Blog Post Titles to rank higher in search engines. Use the keywords given below to optimize the title for SEO.',
    },
    BLOG_CONTENT: {
        title: 'Generates Blog Post Content',
        prompt: 'Check out the product URL and generate a SEO optimized long-form blog article from a first person plural perspective about the title and the product, with the tone of voice as given below. Group the related content by sections with catchy headings and expand them with more detailed content. The content need to be with high quality and very much useful to the buyers to rank high in the search engines.'
    },
    EXPAND_BLOG_CONTENT: {
        title: 'Generates Expanded Blog Post Content',
        prompt: 'Rewrite and Expand the above content with more detail. Group the related content by sections with catchy headings and expand them with more detailed content. ',
    },
    EXPAND_CONTENT: {
        title: 'Generates Expanded Content',
        prompt: 'Expands the below content with more information.',
    },
    CONTENT_EXCERPTS: {
        title: 'Generates Content Excerpts',
        prompt: 'Write an excerpt for this blog post. The excerpt should be a short summary of the blog post. It should be between 40 to 60 words.',
    },
    REWRITE_SECTION_TITLE: {
        title: 'Rewrites Section Title',
        prompt: 'Rewrite the Section Title based on the content given below.',
    },
    REWRITE_CONTENT: {
        title: 'Rewrites Content',
        prompt: 'Rewrite the below content.',
    },
    EXTRACT_KEYWORDS_AND_MAP_LINKS: {
        title: 'Extracts Keywords and Maps Links',
        prompt: 'Extract maximum of 8 exact keywords the given content that exists as it is in the content. Map each of those keywords to a url from the URLs list below. Format the mapping like this: Keyword = URL. \nURLs need to be mapped only once.',
    }
}
